import { get } from "../../../utils/objectHelpers";

$ {
    const fallbackText = get(input, "fallbackText", null);
    const renderData = get(input, "renderData", null);
}

<if(renderData)>
    <ebay-eek rating=renderData.rating max=renderData.rangeUpper min=renderData.rangeLower />
</if>
<if(!renderData && fallbackText)>
    <p class="str-eek--fallback"><str-textual-display ...fallbackText /></p>
</if>
